import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index'
import './registerServiceWorker'

import axios from "axios";
import VueAxios from "vue-axios";
import VueSlideoutPanel from 'vue2-slideout-panel';
import * as firebase from "firebase";

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
axios.defaults.headers.common['Content-Type'] = 'application/json';
axios.defaults.baseURL = "https://api.questme.fr/";

Vue.config.productionTip = false;

if (localStorage.getItem("token")) {
  axios.defaults.headers.common = {
    'X-Requested-With': 'XMLHttpRequest',
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${localStorage.getItem("token")}`
  }
}

Vue.use(VueAxios, axios);
Vue.use(VueSlideoutPanel);

let config = {
  apiKey: "AIzaSyC144uOwyJSs_cVpemfMlAEA6IHIRihqbg",
  authDomain: "questme-4c79d.firebaseapp.com",
  databaseURL: "https://questme-4c79d.firebaseio.com",
  projectId: "questme-4c79d",
  storageBucket: "questme-4c79d.appspot.com",
  messagingSenderId: "174534427332",
  appId: "1:174534427332:web:e876b5f9e09924d3"
};

firebase.initializeApp(config);

const messaging = firebase.messaging();

messaging.usePublicVapidKey("BIRKseUNocf8FECW6tlJkdp9Rw7tAiNZUSP-leTmWX6ZJzqyinXgqaLxdIyNu4aPcvfZ3-ONjyrNJ8qT0cydck4");

messaging.requestPermission().then(() => {
  console.log('Notification permission granted.');

  // Get Token
  messaging.getToken().then((token) => {
    //console.log(token)
  })
}).catch((err) => {
  console.log('Unable to get permission to notify.', err);
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')